<template>
    <div style="max-height: 60vh; overflow: auto">
        <el-table :data="cols" :max-height="280">
            <el-table-column label="列名">
                <template slot-scope="{ row }">
                    <span>{{ row.label }}</span>
                </template>
            </el-table-column>
            <el-table-column label="是否隐藏" v-if="hideMode">
                <template slot-scope="{ row }">
                    <el-switch v-model="row.hide" />
                </template>
            </el-table-column>
            <el-table-column label="是否显示" v-else>
                <template slot-scope="{ row }">
                    <el-switch v-model="row.show" />
                </template>
            </el-table-column>
            <el-table-column label="位置" v-if="setColumn">
                <template slot-scope="{ $index }">
                    <div style="display:flex">
                        <div class="sizearea">
                            <i
                                v-if="$index > 1"
                                class="el-icon-upload2 sizebtn"
                                @click="upTop($index)"
                            ></i>
                        </div>
                        <div class="sizearea">
                            <i
                                v-if="$index != 0"
                                class="el-icon-top sizebtn"
                                @click="up($index)"
                            />
                        </div>
                        <div class="sizearea">
                            <i
                                v-if="$index != cols.length - 1"
                                class="el-icon-bottom sizebtn"
                                @click="down($index)"
                            />
                        </div>
                        <div class="sizearea">
                            <i
                                v-if="$index < cols.length - 2"
                                class="el-icon-download sizebtn"
                                @click="downFloor($index)"
                            />
                        </div>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    name: "ColumnEdit",
    props: {
        cols: {
            type: Array,
            default: () => [],
            require: true,
        },
        setColumn: {
            type:Boolean,
            default:true,
        },
        hideMode:{
            type:Boolean,
            default:false,
        }
    },
    data() {
        return {};
    },
    methods: {
        swapArray(arr, index1, index2) {
            let arr1 = arr.splice(index2,1)[0];
            this.$nextTick(()=>{
                arr.splice(index1,0,arr1);
            })
        },
        up(index) {
            this.swapArray(this.cols, index - 1, index);
        },
        upTop(index){
            let arr = this.cols.splice(index,1)[0];
            this.cols.unshift(arr);
        },
        down(index) {
            this.swapArray(this.cols, index, index + 1);
        },
        downFloor(index){
            let arr = this.cols.splice(index,1)[0];
            this.cols.push(arr);
        }
    },
};
</script>
<style scoped>
.sizearea{
    width: 20px;
    height: 22px;
    margin-right: 10px;
}
.sizebtn{
    width: 20px;
    height: 20px;
    line-height: 20px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    color: #606266;
    border-radius: 5px;
    text-align: center;
}
.sizebtn:hover{
    cursor: pointer;
    color: #409eff;
}
</style>
